export default {
    table_2: [
        'index','sn','method','created_time',
    ],
    table_default: [
        'index','sn','method','created_time'
    ]
}